import axios from "axios";
import {store} from "../index"
import _ from 'lodash';

//__API__ definida pelo
const baseUrl = __API__;
const isProducao = __PRODUCAO__;

const http = axios.create({
    baseURL: baseUrl,
    withCredentials: true
});

export { isProducao, http, baseUrl };
